import { APICore } from '../helpers/api/apiCore';
import { findObject } from '../utils/AllFunction';
import { apiReturnCallBack } from './ApiConfig';
import apiContainer from './apiContainer';
const api = new APICore();

const Allotment = apiContainer.Allotment
//GET--->
// Corrected getAllotment function
export async function getAllotmentApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`${Allotment}`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//CREATE---->
export async function createAllotment(request) {
    try {
        return api.create(`${Allotment}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//UPDATE---->
export async function updateAllotment(request, AllotmentId) {
    try {
        return api.update(`${Allotment}/${AllotmentId}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//DELETE---->
export async function deleteAllotment(AllotmentId) {
    try {
        return api.delete(`${Allotment}/${AllotmentId}`);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}



